import React from "react";
import { ArrowRight } from "lucide-react";
import "../../styles/cmyuva.css";

const CmYuvaCTA = ({ setFormActive }) => {
  const handleEnquireNow = () => {
    setFormActive(true);
  };
  return (
    <section className="cmyuva_cta_section position-relative py-5 overflow-hidden">
      {/* Background Overlay */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{ zIndex: -2, backgroundColor: "#0f172a" }}
      ></div>
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background:
            "linear-gradient(45deg, rgba(193,18,31,0.15) 0%, rgba(0,48,73,0.9) 100%)",
          zIndex: -1,
        }}
      ></div>

      <div className="container py-5">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-8 text-start" data-aos="zoom-in">
            <h2 className="display-4 fw-bold text-white mb-4">
              Ready to Transform Your{" "}
              <span style={{ color: "#ef4444" }}>Creative Career?</span>
            </h2>
            <p className="lead text-white-50 mb-5">
              Join the next-generation AI-powered startup ecosystem connecting
              storytelling, skilling, and immersive technology.
            </p>
            <div className="d-flex flex-column flex-sm-row gap-3 justify-content-start">
              <button
                onClick={handleEnquireNow}
                className="cmyuva_btn_primary btn-lg"
              >
                Check Eligibility <ArrowRight size={20} className="ms-2" />
              </button>
              <button
                onClick={() => {
                  window.location.href = "mailto:franchise@hkimedia.com";
                }}
                className="cmyuva_btn_secondary btn-lg"
              >
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CmYuvaCTA;
